@if (label && variant !== 'filter') {
  <label class="ptl-autocomplete-search__label">{{ label }}</label>
}

<div
  class="ptl-autocomplete-search__trigger-row"
  [class.ptl-autocomplete-search__trigger-row--filter]="variant === 'filter'"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
>
  @if (variant === 'filter') {
    <button
      type="button"
      class="ptl-autocomplete-search__filter-trigger"
      [class.is-disabled]="disabled"
      [disabled]="disabled"
      (click)="toggleOpen()"
    >
      @if (label) {
        <span class="ptl-autocomplete-search__filter-label">{{ label }}:</span>
      }
      <span class="ptl-autocomplete-search__filter-value">{{ filterDisplayValue }}</span>
      <svg
        class="ptl-autocomplete-search__filter-chevron"
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>
  } @else {
    @for (opt of selectedOptions; track opt.value) {
      <div
        class="ptl-autocomplete-search__chip"
        [class.is-disabled]="disabled"
        [style.background-color]="opt.dotColor ? 'color-mix(in srgb, ' + opt.dotColor + ' 15%, transparent)' : null"
        [style.border-color]="opt.dotColor ? 'color-mix(in srgb, ' + opt.dotColor + ' 40%, transparent)' : null"
        [style.color]="opt.dotColor || null"
      >
        <button type="button" class="ptl-autocomplete-search__chip-main" [disabled]="disabled" (click)="toggleOpen()">
          @if (opt.dotColor) {
            <span class="ptl-autocomplete-search__dot" [style.background-color]="opt.dotColor"></span>
          }
          <span class="ptl-autocomplete-search__chip-text">{{ opt.label }}</span>
        </button>
        @if (!disabled) {
          <button
            type="button"
            class="ptl-autocomplete-search__chip-remove"
            [attr.aria-label]="removeLabel + ' ' + opt.label"
            (click)="removeChip(opt.value, $event)"
          >
            ×
          </button>
        }
      </div>
    }

    <button type="button" class="ptl-autocomplete-search__add" [disabled]="disabled" (click)="toggleOpen()">
      {{ addLabel }}
    </button>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="close()"
  (detach)="close()"
>
  <div class="ptl-autocomplete-search__popover">
    <div class="ptl-autocomplete-search__search">
      <svg
        class="ptl-autocomplete-search__search-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        class="ptl-autocomplete-search__search-input"
        [value]="searchText"
        [placeholder]="searchPlaceholder"
        [attr.aria-label]="searchAriaLabel || searchPlaceholder"
        (input)="searchText = $any($event.target).value"
      />
    </div>

    <div class="ptl-autocomplete-search__counter">{{ counterLabel }}</div>

    <div class="ptl-autocomplete-search__options">
      @for (opt of filteredOptions; track opt.value) {
        <button
          type="button"
          class="ptl-autocomplete-search__option"
          [class.is-selected]="isSelected(opt.value)"
          [attr.aria-pressed]="isSelected(opt.value)"
          (click)="toggleOption(opt)"
        >
          <span
            class="ptl-autocomplete-search__indicator"
            [class.ptl-autocomplete-search__indicator--checkbox]="multiSelect"
            [class.ptl-autocomplete-search__indicator--radio]="!multiSelect"
            [class.is-checked]="isSelected(opt.value)"
            aria-hidden="true"
          >
            @if (multiSelect && isSelected(opt.value)) {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            }
          </span>
          @if (opt.dotColor) {
            <span class="ptl-autocomplete-search__dot" [style.background-color]="opt.dotColor"></span>
          }
          <span class="ptl-autocomplete-search__option-text">
            <span class="ptl-autocomplete-search__option-label">{{ opt.label }}</span>
            @if (opt.sublabel) {
              <span class="ptl-autocomplete-search__option-sublabel">{{ opt.sublabel }}</span>
            }
          </span>
        </button>
      }
    </div>

    @if (multiSelect) {
      <div class="ptl-autocomplete-search__footer">
        <span class="ptl-autocomplete-search__footer-count">{{ pendingSelection.length }} {{ selectedCountSuffix }}</span>
        <button type="button" class="ptl-autocomplete-search__done" (click)="onDone()">{{ doneLabel }}</button>
      </div>
    }
  </div>
</ng-template>
